const { useQuery } = require("react-query");
const { getSSOLoggedUsers } = require("../api/sso");

export const useGetSSOLoggedUsers = (data, options) => {
  return useQuery(
    ["getSSOLoggedUsers"],
    () => getSSOLoggedUsers(data),
    options,
  );
};

export default {
  useGetSSOLoggedUsers,
};
